import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';

import {defineAbilityConfig} from '../system/defineAbilityConfig';

/**
 * Feature gate for AISB Build Mode.
 * Checks if the site is an AISB site and the aisb-v2 feature flag is enabled.
 */
export const aisbBuilderAbility = defineAbilityConfig({
  features: {aiSiteGen: true},
  featureFlags: {[FEATURE_FLAGS.AISB_V2]: true},
} as const);

/**
 * Determines whether the user is specifically in AISB Build Mode.
 *
 * AISB Build Mode is a subset of Page Build Mode — it is true only when
 * isInPageBuildMode is true AND the AISB feature gate is active
 * (AISB site + aisb-v2 feature flag).
 */
export const isInAisbBuildMode = defineAbilityConfig({
  abilities: {
    isInPageBuildMode: true,
    aisbBuilderAbility: true,
  },
} as const);
